import { MultiSelect, MultiSelectOption } from '@shape-ds/components';
import { Controller, FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormInputProps } from './FormInputProps';
export const ALL_OPTION = 'ALL';

export const FormMultiSelect = <T extends FieldValues>({
  name,
  control,
  label,
  selectOptionData,
  isRequired,
  disabled,
  readOnly,
  onChangeCallback,
  allLabel,
  defaultValues = ['ALL'],
}: FormInputProps<T> & {
  allLabel?: string;
  onChangeCallback?: (newValue: MultiSelectOption[]) => void;
  defaultValues?: string[];
}): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: isRequired ? t('components:inputs.required_field') : false }}
      render={({ field: { onChange, value }, fieldState: { error }, formState }) => {
        const arrayValue = Array.isArray(value) ? value : value ? [value] : defaultValues;

        return (
          <div className={name.replace(/\./g, '-')}>
            <MultiSelect
              fullWidth
              required={isRequired}
              data-testid={name}
              onChangeCallback={(selectedItems) => {
                onChange(
                  selectedItems.length > 0
                    ? selectedItems.map((item) => item.value)
                    : defaultValues,
                );
                onChangeCallback?.(selectedItems);
              }}
              initialValues={defaultValues}
              allValues={{ label: allLabel ?? t('glossary:all.all'), value: 'ALL' }}
              error={!!error}
              label={label}
              data={selectOptionData || []}
              value={arrayValue}
              disabled={disabled}
              readOnly={formState.disabled || readOnly}
            />
          </div>
        );
      }}
    />
  );
};
